import { produce } from "immer";
import { Actions } from "./action";

export interface TimeslotState {
    zipCodes?: ZipCodeDepartmentAvailability[];
    availableDepartmentBooking?: AvailableDepartmentBooking[];
    year?: number;
    month?: number;
}

const initialState: TimeslotState = {
};

export const reducer = (
    uiState = initialState,
    action: Actions
): TimeslotState =>
    produce(uiState, draft => {
        switch (action.type) {
            case "UPDATE_AVAILABLE_TIMESLOTS": {
                draft.availableDepartmentBooking = action.timeslots;
                draft.year = action.year;
                draft.month = action.month;
                return;
            }
            case "ZIPCODE_DEPARTMENT": {
                draft.zipCodes = action.zipCodeDepartments;
                return;
            }
        }
    });

// A mobile department only drives out on the weekdays its zip code is served
const isServedOnDay = (zip: ZipCodeDepartmentAvailability, date: Date) =>
    [zip.sunday, zip.monday, zip.tuesday, zip.wednesday, zip.thursday, zip.friday, zip.saturday][date.getDay()];

// The state is frozen by immer, so the closed days are copies; the last result is kept so
// connect() doesn't get a new array on every store update
let lastAvailable: { input: TimeslotState; result?: AvailableDepartmentBooking[] } | undefined;

export const getAvailableDepartmentBooking = (state: TimeslotState) =>
{
    if (
        lastAvailable &&
        lastAvailable.input.availableDepartmentBooking === state.availableDepartmentBooking &&
        lastAvailable.input.zipCodes === state.zipCodes &&
        lastAvailable.input.year === state.year &&
        lastAvailable.input.month === state.month
    )
    {
        return lastAvailable.result;
    }

    let result = state.availableDepartmentBooking;
    if(state.zipCodes && state.zipCodes.length > 0 && state.availableDepartmentBooking && state.year && state.month)
    {
        const year = state.year;
        const month = state.month;
        const zip = state.zipCodes[0];

        result = state.availableDepartmentBooking.map(data =>
            isServedOnDay(zip, new Date(year, month - 1, data.dayOfMonth))
                ? data
                : { ...data, stoneChipAvailable: false, windowReplaceAvailable: false }
        );
    }

    lastAvailable = { input: state, result };
    return result;
}

export const getZipCodes = (state: TimeslotState) => state.zipCodes;

export default reducer;